import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { SyllabusSelectComponent } from '@examdojo/category';
import { FeatureFlagDirective } from '@examdojo/core/feature-flag';
import { IconComponent } from '@examdojo/core/icon';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { provideFaIcons } from '@examdojo/icons';
import { ExamDojoFeatureFlag } from '@examdojo/models/feature-flag';
import { AuthService, IfUserHasRoleDirective, ProfileAvatarComponent, UserQuery } from '@examdojo/user';
import { faLanguage } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs';
import { CmsUrlParts, SYLLABUS_SLUG_PARAM } from '../cms/cms.model';
import { LanguagePickerDialogService } from './language-picker-dialog/language-picker-dialog.service';

@Component({
  selector: 'exam-shell',
  imports: [
    RouterLink,
    IfUserHasRoleDirective,
    MatSidenav,
    MatSidenavContent,
    MatSidenavContainer,
    IconComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    ProfileAvatarComponent,
    RouterOutlet,
    SyllabusSelectComponent,
    RouterLinkActive,
    NgTemplateOutlet,
    TranslocoPipe,
    FeatureFlagDirective,
    MatTooltipTruncateDirective,
    MatTooltip,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  host: { class: 'h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LanguagePickerDialogService],
})
export class ShellComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly userQuery: UserQuery,
    private readonly languagePickerDialogService: LanguagePickerDialogService,
    private readonly route: ActivatedRoute,
  ) {
    provideFaIcons([faLanguage]);
  }

  readonly state = connectState({
    signedIn: this.authService.signedIn$,
    user: this.userQuery.active$,
    syllabusSlug: this.route.paramMap.pipe(map((params) => params.get(SYLLABUS_SLUG_PARAM) || '')),
  });

  readonly CmsUrlParts = CmsUrlParts;
  readonly ExamDojoFeatureFlag = ExamDojoFeatureFlag;

  logout() {
    this.authService.signOut();
  }

  openLanguageDialog() {
    this.languagePickerDialogService.openDialog();
  }
}
